/**
 * FAQPage structured data. Google reads this to build the rich result for a
 * page whose questions are behind an accordion, where the answers are in the
 * markup but not visible on load.
 *
 * Rendered into the tree so the static SSR pass bakes it into the HTML — a
 * crawler that never runs our JavaScript still sees it.
 */

export type FaqJsonLdItem = {
  question: string;
  answer: string;
};

export interface FaqJsonLdProps {
  items: FaqJsonLdItem[];
}

export function FaqJsonLd({ items }: FaqJsonLdProps) {
  if (items.length === 0) {
    return null;
  }
  const data = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: { '@type': 'Answer', text: item.answer },
    })),
  };
  return (
    <script
      type="application/ld+json"
      // The content is our own translation strings, not anything user-entered.
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
